module.exports = __webpack_public_path__ + "img/atari_joust_ad.a99c0799.jpg";